import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import GreeniaMark from './GreeniaMark';
import QuoteInfo from './QuoteInfo';
import AccidentInfo from './AccidentInfo';
import SuspensionInfo from './SuspensionInfo';
import ReplacementInfo from './ReplacementInfo';
import CancellationInfo from './CancellationInfo';
import ModificationInfo from './ModificationInfo';
import NewQuoteInfo from './NewQuoteInfo';
import NewProfessionQuoteInfo from './NewProfessionQuoteInfo';
import CommercialQuoteInfo from './CommercialQuoteInfo';
import TravelQuoteInfo from './TravelQuoteInfo';
import ProfessioneSanitaQuoteInfo from './ProfessioneSanitaQuoteInfo';
import MediciDipendentiQuoteInfo from './MediciDipendentiQuoteInfo';
import MedicoProtettoInfo from './MedicoProtettoInfo';
import MLPQuoteInfo from './MLPQuoteInfo';
import HouseQuoteInfo from './HouseQuoteInfo';
import CondominioQuoteInfo from './CondominioQuoteInfo';
import RcFamigliaQuoteInfo from './RcFamigliaQuoteInfo';

function AiMessage({
  quote, message, accident, suspension, replacement, cancellation, modification, newQuote, fastQuoteId, professionQuote, setShowGreeniaAI, commercialQuote, travelQuote, professioniSanitaQuote, mediciDipendentiQuote, medicoProtettoQuote, medicoLiberoProfessionistaQuote, houseQuote, condominioQuote, rcFamigliaQuote,
}) {
  const hasExtra = quote || accident || suspension || replacement || cancellation
    || modification || newQuote || professionQuote || commercialQuote
    || travelQuote || professioniSanitaQuote || mediciDipendentiQuote || medicoProtettoQuote
    || medicoLiberoProfessionistaQuote || houseQuote || condominioQuote || rcFamigliaQuote;

  return (
    <>
      <div className="msg-row ai">
        <div className="msg-avatar">
          <GreeniaMark />
        </div>
        <div className="bubble">
          <div className="sender">Greenia AI</div>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(marked.parse(message ?? '', { breaks: true })) }} />
        </div>
      </div>
      {hasExtra && (
        <div className="ai-extra">
          {quote && <QuoteInfo quote={quote} />}
          {accident && <AccidentInfo accident={accident} setShowGreeniaAI={setShowGreeniaAI} />}
          {suspension && <SuspensionInfo suspension={suspension} setShowGreeniaAI={setShowGreeniaAI} />}
          {replacement && <ReplacementInfo replacement={replacement} setShowGreeniaAI={setShowGreeniaAI} />}
          {cancellation && <CancellationInfo cancellation={cancellation} setShowGreeniaAI={setShowGreeniaAI} />}
          {modification && <ModificationInfo modification={modification} setShowGreeniaAI={setShowGreeniaAI} />}
          {newQuote && <NewQuoteInfo newQuote={newQuote?.data} discounted_amount={newQuote?.discounted_amount} companies={newQuote?.companies} fastQuoteId={fastQuoteId} setShowGreeniaAI={setShowGreeniaAI} />}
          {professionQuote && <NewProfessionQuoteInfo professionQuote={professionQuote} setShowGreeniaAI={setShowGreeniaAI} />}
          {commercialQuote && <CommercialQuoteInfo commercialQuote={commercialQuote} setShowGreeniaAI={setShowGreeniaAI} />}
          {travelQuote && <TravelQuoteInfo travelQuote={travelQuote} setShowGreeniaAI={setShowGreeniaAI} />}
          {professioniSanitaQuote && <ProfessioneSanitaQuoteInfo professioniSanitaQuote={professioniSanitaQuote} setShowGreeniaAI={setShowGreeniaAI} />}
          {mediciDipendentiQuote && <MediciDipendentiQuoteInfo mediciDipendentiQuote={mediciDipendentiQuote} setShowGreeniaAI={setShowGreeniaAI} />}
          {medicoProtettoQuote && <MedicoProtettoInfo mediciProtettoQuote={medicoProtettoQuote} setShowGreeniaAI={setShowGreeniaAI} />}
          {medicoLiberoProfessionistaQuote && (
            <MLPQuoteInfo
              medicoLiberoProfessionistaQuote={medicoLiberoProfessionistaQuote}
              setShowGreeniaAI={setShowGreeniaAI}
            />
          )}
          {houseQuote && <HouseQuoteInfo houseQuote={houseQuote} setShowGreeniaAI={setShowGreeniaAI} />}
          {condominioQuote && <CondominioQuoteInfo condominioQuote={condominioQuote} setShowGreeniaAI={setShowGreeniaAI} />}
          {rcFamigliaQuote && <RcFamigliaQuoteInfo rcFamigliaQuote={rcFamigliaQuote} setShowGreeniaAI={setShowGreeniaAI} />}
        </div>
      )}
    </>
  );
}

export default AiMessage;
